@if (currentBannerImg) {
<href class="ratio-banner w-12"
      (click)="trackClick()"
      [link]="currentBanner?.redirectUrl">
    <img [image]="currentBannerImg"
         [options]="{fitIn: true}"
         class="rf">
</href>
}